const getInitialState = () => ({
  invoiceLimitExceeded: 0.0
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {
    getInvoiceLimitExceededValue(state) {
      return state.invoiceLimitExceeded
    }
  },

  mutations: {
    SET_INVOICE_LIMIT_EXCEEDED(state, invoiceLimitExceeded) {
      state.invoiceLimitExceeded = invoiceLimitExceeded
    },

    CLEAN_PAY_BOX_INVOICE_METADATA(state) {
      state.invoiceLimitExceeded = 0.0
    },

    CLEAN_STATE(state) {
      const defaultData = getInitialState()
      Object.keys(defaultData).forEach(key => {
        state[key] = defaultData[key]
      })
    },
  },

  actions: {
    async validateInvoiceExceededLimits({ commit, dispatch, rootGetters }, { totalSaleValue }) {
      const filterLimit = async (limits, model, state) => {
        const result = limits.filter(limit => limit.model === model && limit.originState === state)
        return result.length > 0 ? JSON.parse(JSON.stringify(result[0])) : null
      }

      await dispatch('pages/pdv/payBox/setElectronicInvoiceRequired', false, { root: true, })

      const { store: payBoxStore, preferredInvoiceType } =
        rootGetters['pages/pdv/payBoxConfiguration/currentPayboxConfiguration']
      const invoiceLimits = rootGetters['pages/pdv/getInvoiceLimits']

      const limits = await filterLimit(
        invoiceLimits,
        preferredInvoiceType,
        payBoxStore?.address?.province
      )

      if (limits != null && limits.maximumTotal != null && limits.maximumTotal > 0) {
        if (
          limits.maximumTotalWithouIdentification != null &&
          totalSaleValue > limits.maximumTotalWithouIdentification &&
          totalSaleValue < limits.maximumTotal
        ) {
          commit("SET_INVOICE_LIMIT_EXCEEDED", limits.maximumTotalWithouIdentification > 0
            ? limits.maximumTotalWithouIdentification
            : limits.maximumTotal)

          return true
        }

        if (totalSaleValue > limits.maximumTotal) {
          commit("SET_INVOICE_LIMIT_EXCEEDED", limits.maximumTotalWithouIdentification > 0
            ? limits.maximumTotalWithouIdentification
            : limits.maximumTotal)
          await dispatch('pages/pdv/payBox/setElectronicInvoiceRequired', true, { root: true, })
          return true
        }
      }

      return false
    },

    async cleanPayBoxInvoiceMetadata({ commit }) {
      commit('CLEAN_PAY_BOX_INVOICE_METADATA')
    }
  },
}
